class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', event => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-drawer-items') ||
        this.closest('cart-items');

      // update quantity of the item to 0
      cartItems.updateQuantity(this.dataset.index, 0);

      try {
        // the item that has been deleted
        const DELETED_ITEM = getCartItemFromIndex(this.dataset.index);
        const SUBTOTAL_AMOUNT = parseFloat(document.getElementById('cart__subtotal_total').dataset.amount);

        // send remove_from_cart event
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'remove_from_cart',
          ecommerce: {
            'ecomm_prodid': DELETED_ITEM.id,
            'ecomm_totalvalue': SUBTOTAL_AMOUNT,
            'ecomm_pagetype': 'cart',
            'value': SUBTOTAL_AMOUNT,
            'currency': 'EUR', // TODO
            'items': [
              DELETED_ITEM,
            ],
          },
        });
      } catch (e) {
        console.warn('Failed sending event to dataLayer', e);
      }
    });
  }
}

function getCartItemFromIndex(index) {
  try {
    const cartItemElement = document.getElementById(`CartItem-${index}`);
    const priceElement = cartItemElement.querySelector('.cart-item__price');

    return {
      id: cartItemElement.dataset.ecomm_prodid,
      name: cartItemElement.dataset.ecomm_name,
      brand: cartItemElement.dataset.ecomm_brand,
      category: '',
      coupon: '',
      price: priceElement.dataset ? parseFloat(priceElement.dataset.price_raw) : 0,
      quantity: 0,
      variant: cartItemElement.dataset.ecomm_variant,
    };
  } catch (e) {
    console.error('Error getting cart item from index', e);
    return null;
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.progress = this.getAttribute('data-progress');
  }

  connectedCallback() {
    setTimeout(() => {
      this.querySelector('[data-progress-line]').style.width = this.progress;
    }, 100);
  }
}

customElements.define('progress-bar', ProgressBar);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );
    this.debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, 300);
    this.addEventListener(
      'change',
      this.debouncedOnChange.bind(this)
    );
  }

  onChange(event) {
    if (event.target.name !== 'updates[]') return;

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    return [
      {
        id: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        }`,
        section:
          document.getElementById('main-cart-items').dataset.id,
        selector: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        } cart-items`
      },
      {
        id: '#cart-counter',
        section: 'cart-counter',
        selector: '#shopify-section-cart-counter'
      }
    ];
  }

  /**
   * Update the cart summary button
   */
  updateCartSummaryButton() {
    // find by class name "cart__summary-button"
    const cartSummaryButton = document.querySelector('.cart__summary-button');

    console.log('button', cartSummaryButton);

    if (cartSummaryButton) {
      let savedText = cartSummaryButton.textContent;

      cartSummaryButton.classList.add('is-loading');
      cartSummaryButton.textContent = 'LOADING';
      console.log('loading');

      setTimeout(() => {
        cartSummaryButton.classList.remove('is-loading');
        cartSummaryButton.textContent = savedText;
        console.log('loaded');
      }, 3000);
    }
  }

  updateQuantity(line, quantity, name) {
    this.classList.add('is-loading');

    // dispatch event for cart items to reload
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('onLoadCartItems'));
    }, 2500);
    
    // this.updateCartSummaryButton();

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(
        section => section.section
      ),
      sections_url: window.location.pathname == "/apps/advanced-wishlist" ? "/" : window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            section.id === '#cart-counter'
              ? document.querySelector(section.id)
              : document.querySelector(section.selector);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();
    })
      .finally(() => setTimeout(() => this.classList.remove('is-loading'), 2000));
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .querySelectorAll(
          `[data-line-item-error][data-line="${line}"]`
        )
        .forEach(error => {
          error.innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.querySelector(`[id*="ProductQuantity-${line}"]`)
              .value
          );
        });
    }

    this.currentItemCount = itemCount;
  }
}

customElements.define('cart-items', CartItems);
